var _ellipse, _ellipse2, _ellipse3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 199,
    viewBox: "0 0 200 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.2679,
    cy: 99.5,
    rx: 99.2679,
    ry: 99.5,
    transform: "matrix(1 0 -0.000139668 1 0.746094 0)",
    fill: "#DBE0F1"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.8274,
    cy: 74,
    rx: 73.8274,
    ry: 74,
    transform: "matrix(1 0 -0.000139668 1 26.0205 26)",
    fill: "#3655B3",
    fillOpacity: 0.34
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.9933,
    cy: 35.958,
    rx: 37.9933,
    ry: 35.958,
    transform: "matrix(1 0 -0.000139668 1 61.7285 60)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.2188 156C88.0441 156 77.1204 152.686 67.8291 146.478C58.5377 140.27 51.296 131.446 47.0196 121.122C42.7433 110.798 41.6243 99.4373 43.8044 88.4774C45.9845 77.5175 51.3656 67.4502 59.2673 59.5485C67.1689 51.6468 77.2362 46.2657 88.1962 44.0857C99.1561 41.9056 110.516 43.0245 120.84 47.3008C131.164 51.5772 139.989 58.8189 146.197 68.1103C152.405 77.4017 155.719 88.3254 155.719 99.5C155.719 114.485 149.766 128.856 139.17 139.452C128.574 150.047 114.204 156 99.2188 156ZM67.2285 112.241C66.0135 111.012 65.332 109.354 65.332 107.627C65.332 105.899 66.0135 104.241 67.2285 103.012L70.5545 99.7053C71.1201 99.1346 71.7946 98.6833 72.538 98.3782C73.2814 98.0732 74.0785 97.9206 74.882 97.9296C75.6855 97.9385 76.479 98.1088 77.2154 98.4303C77.9518 98.7519 78.6161 99.2181 79.1688 99.8014L85.0448 105.898C85.325 106.193 85.6625 106.429 86.0366 106.59C86.4108 106.751 86.8138 106.834 87.221 106.834C87.6283 106.834 88.0313 106.751 88.4055 106.59C88.7796 106.429 89.117 106.193 89.3972 105.898L119.342 75.0298C119.899 74.4425 120.569 73.9738 121.311 73.652C122.054 73.3302 122.854 73.1618 123.663 73.1571C124.472 73.1523 125.274 73.3113 126.02 73.6244C126.767 73.9375 127.442 74.3983 128.005 74.979L131.235 78.2447C132.421 79.468 133.084 81.1046 133.084 82.808C133.084 84.5114 132.421 86.148 131.235 87.3713L91.4801 127.771C90.9254 128.345 90.2615 128.803 89.5275 129.117C88.7935 129.431 88.004 129.596 87.2055 129.601C86.407 129.607 85.6156 129.452 84.8775 129.148C84.1393 128.843 83.4695 128.394 82.9072 127.827L67.2285 112.241Z",
    fill: "#3655B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.6ee59c3093004addbd99a10f12323168.svg";
export { ForwardRef as ReactComponent };